export default __webpack_public_path__ + "static/print1-bdd9a37f2ea379003f46ba58aa665202.webp";